import Alert from "@mui/material/Alert";

function NotFound() {
    return (
        <Alert severity="error" data-testid="notFound">
            Error 404 - Page Not Found
        </Alert>
    );
}

export default NotFound;
